export default "<app-wo-stopped-list [orderStatus]=\"'TR'\" [allowRecover]=\"true\"></app-wo-stopped-list>\n"